import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import Icon from '@material-ui/core/Icon';

// Input de busca que começa recolhido (só o ícone) e expande ao clicar, com foco automático
// e transição de largura. Só volta a recolher quando perde o foco E está vazio.
const SearchInput = ({ value, onChange, placeholder }) => {
  const [expanded, setExpanded] = useState(!!value);
  const inputRef = useRef(null);

  useEffect(() => {
    if (expanded && inputRef.current) {
      inputRef.current.focus();
    }
  }, [expanded]);

  const handleBlur = () => {
    if (!value) {
      setExpanded(false);
    }
  };

  return (
    <div
      className={`ds-search-input ${expanded ? 'is-expanded' : 'is-collapsed'}`}
      onClick={() => setExpanded(true)}
    >
      <span className="ds-search-icon-wrap">
        <Icon className="ds-search-icon">search</Icon>
      </span>
      <input
        ref={inputRef}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onBlur={handleBlur}
        placeholder={placeholder}
        tabIndex={expanded ? 0 : -1}
      />
    </div>
  );
};

SearchInput.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
};

SearchInput.defaultProps = {
  placeholder: 'Buscar...',
};

export default SearchInput;
